
        var result = require("!!../../../../node_modules/css-loader/index.js!./p.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/components/micro-components/p-component/p.component.css
// module id = 17
// module chunks = 0 1